import { BaseLookup } from "./BaseLookup";

export class Sport extends BaseLookup {
    sortOrder: number;
}